<template>
  <v-dialog v-model="dialog" max-width="500px">
    <v-form ref="form" @submit.prevent="() => $emit('salvar', filial)">
      <v-card v-if="filial" :loading="salvando">
        <v-card-title> {{ operacao === 'editar' ? 'Editar' : 'Adicionar' }} Filial </v-card-title>
        <v-card-text>
          <v-form ref="formDialog" v-model="validForm" @submit.prevent>
            <v-container>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="filial.nome"
                    label="Nome"
                    required
                    :rules="[obrigatorio]"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <CampoDeCpfOuCnpj
                    v-model="filial.documento"
                    label="CPF / CNPJ"
                    :disabled="operacao === 'editar'"
                  />
                </v-col>
              </v-row>
              <v-switch v-if="operacao === 'editar'" v-model="filial.status" label="Ativo" dense />
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-alert v-if="showMessageError" dense outlined type="error">
                    {{ dataError }}
                  </v-alert>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" type="button" text @click="dialog = false">Cancelar</v-btn>
          <v-btn
            class="ml-auto"
            type="submit"
            text
            color="success"
            :disabled="!validForm"
            @click="salvar(filial)"
            >Salvar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import Filial from '@/models/filial'
import FilialService from '@/services/empresa/filial'
import { obrigatorio } from '@/shareds/regrasForm'
import CampoDeCpfOuCnpj from '@/components/ui/CampoDeCpfOuCnpj.vue'

export default {
  components: { CampoDeCpfOuCnpj },
  props: ['showDialogVinculo', 'filialParam', 'operacao', 'empresa', 'itens'],
  data: () => ({
    dialog: false,
    filial: new Filial(),
    showMessageError: false,
    obrigatorio: obrigatorio,
    salvando: false,
    validForm: false,
    dataError: ''
  }),
  watch: {
    showDialogVinculo() {
      this.showMessageError = false
      return this.showDialogVinculo ? (this.dialog = this.showDialogVinculo) : ''
    },
    filialParam() {
      return this.filialParam ? this.initialize() : ''
    },
    dialog() {
      return this.dialog ? true : this.fecharDialog()
    }
  },
  methods: {
    initialize() {
      this.filial = new Filial()
      if (this.$refs.formDialog) this.$refs.formDialog.resetValidation()

      this.filial = this.filialParam
    },

    async salvar(item) {
      this.salvando = true
      this.showMessageError = false
      try {
        const data = {
          ...item,
          documento: item.documento.replaceAll('.', '').replaceAll('/', '').replaceAll('-', ''),
          empresa: this.empresa
        }

        const filialSalva =
          this.operacao === 'adicionar'
            ? await FilialService.create({ ...data, status: true })
            : await FilialService.update(data)

        this.$emit('confirmado', filialSalva)
        this.dialog = false
      } catch (error) {
        this.dataError = error.response.data.message
        this.showMessageError = true
      } finally {
        this.salvando = false
      }
    },

    fecharDialog() {
      this.$emit('update:showDialogVinculo', false)
    }
  }
}
</script>
